export default {
  "labels": {
    "averageShiftTime": "Dia normal",
    "quantityLongRest": "Pausas de 48 horas",
    "drivenTimeMidnight": "Horas de condução entre 0:00 e 6:00",
    "drivenTimeSunRise": "Horas de condução entre 3:00 e 5:00",
    "shiftOverThreshPercentage": "Dias acima de 12 horas",
    "startShiftDifferenceTime": "Dias de início da diferença",
    "lowerRestTime": "Intervalos de 8 horas não cumpridos após o início de um dia",
    "lowerRestTimeQuantity": "Número de vezes que, após o início do dia, o intervalo mínimo legal de 8 horas contínuas não é cumprido nas 24 horas anteriores ao início do dia.",
    "lowerRestTimeAverage": "Média do número de vezes que, após o início do dia, o intervalo mínimo legal de 8 horas contínuas não é cumprido nas 24 horas anteriores ao início do dia.",
    "detailMainIndicators": "Detalhe dos principais indicadores",
    "startShift": "Horários de início do dia",
    "rotation": "Rotação",
    "shiftLength": "Duração dos dias",
    "consecutiveWorkingDays": "Dias consecutivos trabalhados",
    "evFatigue": "EV. FATIDA",
    "noteDaily": "NOTA DIÁRIA",
    "averageShiftTimeText": "Duração média em horas dos turnos diários dos motoristas.",
    "quantityLongRestTextDriverView": "Número de pausas de 48 horas no intervalo selecionado.",
    "quantityLongRestText": "Número médio de pausas de 48 horas para cada motorista no intervalo selecionado.",
    "drivenTimeMidnightText": "Média de horas conduzidas neste intervalo, representando a condução noturna.",
    "drivenTimeSunRiseText": "Média de horas conduzidas neste intervalo, representando uma condução noturna crítica. Neste momento há até 20 vezes mais probabilidade de ocorrer um acidente, por isso é importante monitorá-lo.",
    "shiftOverThreshPercentageText": "Percentual de turnos diários superiores a 12 horas, desde o início do turno até o final do mesmo.",
    "startShiftDifferenceTimeText": "Diferença em horas entre as horas de início de um dia e do dia seguinte. Por exemplo, se um motorista começa a trabalhar às 7h30 de um dia e às 9h30 do dia seguinte, essa diferença é de 2 horas.",
    "lowerRestTimePercentageText": "Percentual de pausas que não atendem ao mínimo legal de 8 horas de descanso contínuo.",
    "startDay": "Começo do dia às",
    "times": "vezes",
    "timeDay": "Hora do dia",
    "betweenStartShifts": "entre o início dos turnos",
    "hoursBetweenStartShifts": "Horas entre o início dos turnos",
    "durationDay": "Duração do dia",
    "durationHours": "Duração (horas)",
    "days": "Dias",
    "consecutive": "consecutivos",
    "consecutiveDays": "Dias consecutivos"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/fatigue/fatigueIndicators.js